export default class MobileNavigation {

  constructor() {
    this.body = document.querySelector('body');
    this.toggleButton = document.querySelector('.toggle-button');
    this.toggleButton.addEventListener('click', () => this.toggleMenu());
    this.body.addEventListener('keydown', (e) => this.hideMenuAfterPressEsc(e));
    this.hideMenu();
  }

  toggleMenu() {
    this.body.classList.toggle('nav-open');
    let ariaExpanded = this.toggleButton.getAttribute('aria-expanded');
    if (ariaExpanded == 'false') {
      this.toggleButton.setAttribute('aria-expanded', 'true');
    } else {
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }
  }

  hideMenuAfterPressEsc(e) {
    const escapeCode = 27;
    let isMenuOpen = false;
    if (this.body.classList.contains('nav-open')) {
      isMenuOpen = true;
    } else {
      isMenuOpen = false;
    }
    if (e.keyCode === escapeCode && isMenuOpen) {
      this.body.classList.remove('nav-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }
  }

  hideMenu() {
    const header = document.querySelector('.header');
    $(window).click((e) => {
      if (this.body.classList.contains('nav-open') && e.target !== header && !header.contains(e.target)) {
        this.body.classList.remove('nav-open');
      }
    });

    this.body.click(event => event.stopPropagation());
  }

}



// WEBPACK FOOTER //
// ./scripts/mobileNavigation.js